<template>
  <div
    v-if="client"
    class="flex items-center like-h5"
  >
    <span>
      {{ clientName }}
    </span>
    <div v-if="client.notes_count">
      <el-tooltip
        placement="top"
      >
        <div class="flex items-center">
          <icon-notes class="text-muted w-3.5 h-4 ml-2" />
        </div>
        <template #content>
          Poznámka
        </template>
      </el-tooltip>
    </div>
    <RequestWarningBadge
      :client="client"
      :request="request"
      class="ml-2"
    />
    <OnlineStatus
      class="ml-2"
      :is-online="client.is_online"
    />
  </div>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
    request: {
      type: Object,
      default: null,
    },
  },

  computed: {
    clientName() {
      if (this.client.name) {
        return this.client.name;
      }

      if (this.client.first_name && this.client.last_name) {
        return `${this.client.first_name} ${this.client.last_name}`;
      }

      return 'Dočasný uživatel';
    },
  },
};
</script>
